// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveTransferMajorGeneralEducationTypeDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import TransferMajorGeneralEducationTypeDTO from '../models/TransferMajorGeneralEducationTypeDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    transferMajorGeneralEducationTypeId: number;
    transferMajorGeneralEducationType: TransferMajorGeneralEducationTypeDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            transferMajorGeneralEducationTypeId: 0,
            transferMajorGeneralEducationType: null,
        },
        initValues);
    },
    transferMajorGeneralEducationTypeId: 'transferMajorGeneralEducationTypeId',
    transferMajorGeneralEducationType: 'transferMajorGeneralEducationType',
}

interface Result extends ResultDTO {
    transferMajorGeneralEducationType: TransferMajorGeneralEducationTypeDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            transferMajorGeneralEducationType: null,
        },
        initValues);
    },
    transferMajorGeneralEducationType: 'transferMajorGeneralEducationType',
}

export { Request, Result };